// extracted by mini-css-extract-plugin
export var active = "_k6-2";
export var recordingDot = "_k6-1";
export var recordingIndicator = "_k6-0";